<template>
    <v-btn id="add-candidate-button"
           :disabled="isDisabled"
           name="add-candidate-button"
           ref="add-candidate-button"
           @click="onClick"
    >
        <v-icon class="material-icons">add_photo_alternate</v-icon>
<!--        <tippy-->
<!--            v-if="startTips == 4"-->
<!--            :onHide="-->
<!--						() => {-->
<!--							if (startTips == 4) return false;-->
<!--						}-->
<!--					"-->
<!--            showOnInit="true"-->
<!--            theme="&#45;&#45;start"-->
<!--            to="add-candidate-button"-->
<!--            placement="bottom"-->
<!--        >-->
<!--            <span class="step">4 of 5</span>-->
<!--            <span class="title">Save your look as a Candidate</span>-->
<!--            <span class="description">Once you are happy with the look you have created, you can save it as a Candidate. Candidates can easily be copied to other assets to share the same look.</span>-->
<!--            <a href="https://fylm.ai/docs/what-are-candidates-and-how-do-i-use-them" target="_blank">Learn more</a>-->
<!--        </tippy>-->
        <tippy showOnInit="false" theme="" to="add-candidate-button" placement="bottom">
            Save look as a Candidate
        </tippy>
    </v-btn>

</template>

<script>
import CanMixin from "@/mixins/CanMixin";
import FilenameMixin from "@/mixins/Filename";
import { mapState } from "vuex";

export default {
    mixins: [CanMixin, FilenameMixin],
    mounted() {
        this.$root.$refs.addCandidateButton = this.$refs['add-candidate-button'];
    },
    computed: {
        ...mapState("App", ["IDT", "blockLoading"]),
        ...mapState("Projects", ['image']),
        ...mapState("UI", ["startTips"]),
        isDisabled() {
            return !this.canCreateAssets || !this.image || this.IDT.initial || this.blockLoading
        }
    },
    methods: {
        onClick() {
            if (this.isDisabled) return;

            // if (this.startTips == 4) {
            //     this.$store.dispatch("UI/setStartTips", 4.5);
            // }

            window.UI.showModal(window.UI.modals.newCompare.el);
        }
    }
}
</script>